import { render, staticRenderFns } from "./JxdOrderListDetail.vue?vue&type=template&id=4fd80d5e&scoped=true"
import script from "./JxdOrderListDetail.vue?vue&type=script&lang=js"
export * from "./JxdOrderListDetail.vue?vue&type=script&lang=js"
import style0 from "./JxdOrderListDetail.vue?vue&type=style&index=0&id=4fd80d5e&prod&lang=less"
import style1 from "./JxdOrderListDetail.vue?vue&type=style&index=1&id=4fd80d5e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd80d5e",
  null
  
)

export default component.exports